// https://chakra-ui.com/docs/styled-system/theming/customize-theme
import { extendTheme } from '@chakra-ui/react';

import { theme as republicTheme } from '@r-client/republic/ui/theme';

import { Alert } from './components/alert';
import { Badge } from './components/badge';
import { Button } from './components/button';
import { Checkbox } from './components/checkbox';
import { Heading } from './components/heading';
import { Input } from './components/input';
import { Menu } from './components/menu';
import { Modal } from './components/modal';
import { NumberInput } from './components/number-input';
import { Popover } from './components/popover';
import { Radio } from './components/radio';
import { Tabs } from './components/tabs';
import { Tag } from './components/tag';
import { Text } from './components/text';
import { Tooltip } from './components/tooltip';
import { colors } from './foundations/colors';
import { shadows } from './foundations/shadows';
import {
  fontSizes,
  letterSpacings,
  lineHeights,
} from './foundations/typography';

export const theme = extendTheme({
  ...republicTheme,
  colors,
  shadows,
  fontSizes,
  letterSpacings,
  lineHeights,
  components: {
    ...republicTheme.components,
    Alert,
    Badge,
    Button,
    Checkbox,
    Heading,
    Input,
    Menu,
    Modal,
    NumberInput,
    Popover,
    Radio,
    Tabs,
    Tag,
    Text,
    Tooltip,
  },
});
